module.exports = __webpack_public_path__ + "index2.60ee3d23.png";